module.exports = __webpack_public_path__ + "assets/fa-regular-400.f89ea91ecd1ca2db7e09baa2c4b156d1.woff";